import { render, staticRenderFns } from "./couponrecord.vue?vue&type=template&id=1252b578&scoped=true&"
import script from "./couponrecord.vue?vue&type=script&lang=js&"
export * from "./couponrecord.vue?vue&type=script&lang=js&"
import style0 from "./couponrecord.vue?vue&type=style&index=0&id=1252b578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252b578",
  null
  
)

export default component.exports